<template>
  <Error code="404" />
</template>

<script>
export default {
  metaInfo: {title: 'Error'},
}
</script>

<style scoped>

</style>
